export const SET_LOCK_SWITCH_RECORDS = 'LockRecords/Switch/set';
export const SET_LOCK_REPLACE_RECORDS = 'LockRecords/Replace/set';
